import gql from 'graphql-tag';

export default gql`
    query shipmentKaTotalCod($params: paramsShipmentKAs){
        shipmentKaTotalCod(params: $params) {
        cod_price
        }
    } 
`;
